import React from 'react';
import AButton from 'antd-mobile/lib/button';



export default class Button extends AButton {}
